import { render } from "./modal.vue?vue&type=template&id=18984a1a"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/projects-gallery/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18984a1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18984a1a', __exports__)) {
    api.reload('18984a1a', __exports__)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=18984a1a", () => {
    api.rerender('18984a1a', render)
  })

}


export default __exports__